import { render, staticRenderFns } from "./FundRow.vue?vue&type=template&id=51f6a729&scoped=true"
import script from "./FundRow.vue?vue&type=script&lang=js"
export * from "./FundRow.vue?vue&type=script&lang=js"
import style0 from "./FundRow.vue?vue&type=style&index=0&id=51f6a729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f6a729",
  null
  
)

export default component.exports